import { render } from "./DashBoardComponent.vue?vue&type=template&id=604f0e1d"
import script from "./DashBoardComponent.vue?vue&type=script&lang=js"
export * from "./DashBoardComponent.vue?vue&type=script&lang=js"

import "./DashBoardComponent.vue?vue&type=style&index=0&id=604f0e1d&lang=css"

import exportComponent from "C:\\agilS\\agil.webgisprod\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__